/**
 * What a role allows, on its App record card. Roles are a read-only
 * projection of Designer configuration — this panel explains a role, it never
 * edits one.
 */
import React from 'react'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { describeRightsJson } from '@/shared/rights/describeRights'
import { RightsSummary } from '@/shared/rights/RightsSummary'

export interface RoleRightsPanelProps {
  rights: unknown
  roleName?: string
}

export function RoleRightsPanel({ rights, roleName }: RoleRightsPanelProps) {
  const description = describeRightsJson(
    typeof rights === 'string' || (rights && typeof rights === 'object')
      ? (rights as string | Record<string, unknown>)
      : null,
  )

  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Access granted by this role
      </Typography>
      <RightsSummary description={description} showDetail />
      {description.malformed && roleName && (
        <Typography variant="caption" color="text.secondary" display="block">
          Role: {roleName}
        </Typography>
      )}
      <Box sx={{ mt: 1 }}>
        <Typography variant="caption" color="text.secondary">
          Roles are edited in the Designer.
        </Typography>
      </Box>
    </Paper>
  )
}
